export default function useFixedTitle({fixedElement, offset, onSuccess}) {
    const styles = window.getComputedStyle(document.documentElement);
    const scrollOffset = parseInt(styles.getPropertyValue(`--header-height`)) + (window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop) + 40;

    if (scrollOffset >= offset) {
        fixedElement.style.top = `${scrollOffset - parseInt(styles.getPropertyValue('--header-height')) - 40}px`;
        fixedElement.classList.add('absolute');
        fixedElement.classList.remove('fixed');

        onSuccess();
    }
}